<template>
  <el-container class="project_list">
    <el-main>
      <div style="display: flex;justify-content: flex-start;">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addProject">添加</el-button>
      </div>
      <div style="display: flex;justify-content: center;display:inline;">
        <el-input
          placeholder="通过关键字搜索项目..."
          prefix-icon="el-icon-search"
          v-model="keyword"
          style="width: 400px"
          size="mini"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          style="margin-left: 3px"
          @click="searchClick"
        >搜索</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="absencesList"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" align="left" v-if="showEdit || showDelete"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="loginName" label="用户名" width="100" align="center" @click="itemClick"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" width="200" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" width="200" align="center"></el-table-column>
        <el-table-column prop="duration" label="请假时长" width="100" align="center"></el-table-column>
        <el-table-column prop="description" label="说明" width="300" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark"
              :type="scope.row.status ==0 ? 'danger' : 'success'"
              disable-transitions>{{statusName(scope.row.status)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" v-if="showEdit || showDelete">
          <template slot-scope="scope">
            <el-button size="mini" @click="editProject(scope.$index, scope.row)" v-if="showEdit">编辑</el-button>
            <el-popconfirm
              placement="top"
              width="260"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="delProject(scope.row.id)">
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
              </div>
              <el-button size="mini" type="danger" v-if="showDelete" slot="reference" @click="del_confirm_visible=true">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="guest_table_footer">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="currentChange"
          v-show="this.absencesList.length>0"
        ></el-pagination>
      </div>
    </el-main>
    <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisible" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="left" label-suffix="" :model="formData" ref="formData">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="选择用户">
              <el-select v-model="formData.loginName" placeholder="选择用户" size="mini">
                  <el-option
                    v-for="item in users"
                    :key="item.loginName"
                    :label="item.loginName"
                    :value="item.loginName"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="请假时长">
              <el-input
                maxlength="50"
                v-model="formData.duration"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="formData.startTime"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
                @blur="
                  blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)
                "
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="formData.endTime"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                placeholder="结束时间"
                @blur="
                  blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)
                "
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="请假理由">
              <el-input
                maxlength="50"
                v-model="formData.description"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="状态">
              <el-select v-model="formData.status" size="mini" placeholder="状态">
                  <el-option
                    v-for="item in statuses"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveProject">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { getRequest, postRequest, putRequest } from '../../utils/api'
import { HttpStatus } from '../../utils/httpstatus'
import '../../utils/filter_utils'
import {clearObject} from '../../utils/utils'

export default {
  mounted: function () {
    this.loading = true
    this.loadUsers()
    this.loadAbsencesList()
  },
  data () {
    return {
      absencesList: [],
      projectManagers: [],
      projectLeaders: [],
      loading: false,
      pageSize: 15,
      totalCount: 0,
      currentPage: 1,
      selItems: [],
      keyword: '',
      showEdit: true,
      showDelete: true,
      del_confirm_visible: false,
      sel_del_confirm_visible: false,
      deptId: 0,
      leaveId: 0,
      users: [],
      members: [],
      memberIds: '',
      formData: {},
      dlg_title: '请假',
      dialogVisible: false,
      status: '0',
      statuses: [{name: '待审核', value: 0}, {name: '审核通过', value: 1}]
    }
  },
  methods: {
    formatDate (row, column) {
      // 获取单元格数据
      let data = row[column.property]
      return this.$options.filters['formatDateTime'](data)
    },
    loadProject () {
      let _this = this
      getRequest('/absence/index/' + this.projectId).then(
        resp => {
          this.formData = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadUsers () {
      let _this = this
      getRequest('/user/list?deptId=' + this.deptId).then(
        resp => {
          this.users = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadAbsencesList () {
      const _this = this
      var url = '/absence/list/1/' + _this.currentPage + '/' + _this.pageSize
      if (this.keyword !== '') {
        url = url + '&key=' + encodeURIComponent(this.keyword)
      }
      getRequest(url).then(
        resp => {
          _this.absencesList = resp.data.data.absences
          _this.totalCount = resp.data.data.totalCount
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    currentChange (currentPage) {
      this.currentPage = currentPage
      this.loading = true
      this.loadAbsencesList()
    },
    addProject () {
      this.dialogVisible = true
      this.formData = {}
      this.dlg_title = '添加'
    },
    editProject (index, row) {
      this.dialogVisible = true
      this.projectId = row.id
      this.loadProject()
      this.dlg_title = '编辑'
    },
    saveProject () {
      const _this = this
      clearObject(this.formData)
      this.formData.type = 1
      postRequest('/absence/add', this.formData).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible = false
          this.loadAbsencesList()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    delProject (id) {
      let _this = this
      putRequest('/absence/del/' + id).then(
        resp => {
          _this.$message.success('删除成功')
          this.loadProjectList()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    handleSelectionChange (val) {
      this.selItems = val
    },
    searchClick () {
      this.loadProjectList()
    },
    itemClick (row) {
      this.handleEdit(0, row)
      // this.$router.push({ path: '/blogDetail', query: { aid: row.id } })
    },
    statusName (ststus) {
      return ststus === 0 ? '待审核' : '审核通过'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Views/Absence/AbsenceMana.vue